import { FC, useContext, useState, useEffect } from "react";
import useGridFilter, { DefaultGridFilter } from "../../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { DefaultGrid } from "../../../../components/grids/default/defaultGrid";
import { usePluginContext } from "../../../../system/providers/plugin";
import { PluginWrapper } from "../../../../components/plugins";
import { TaskProgramProvider } from "../../../../Services/DataProviders/TaskProgramProvider";
import { ITaskProgramItemDto, ITaskProgramStoresViewDTO } from "../../../../libs/coreapi-dto/dirs/taskProgram";

export interface IUIModel {
    idGlobal: string
    name: string
    mnemocode: string
    codcode: number
    nameshort: string
    deleted: boolean
    dateDeleted: string
    dateModified: string
}

export interface ICopyGridProps extends ISelectorGridProps {
    gridId: string,
    plugin: IPluginSettings,
    baseGridFilter?: IGridFilter,
    id?: string
}

const TaskProgramItemDetailsGrid: FC<ICopyGridProps> = (props) => {
    const appCtx = useAppContext();
    const pluginCtx = usePluginContext();

    const taskProgramProvider = new TaskProgramProvider(appCtx.coreApiService);
    const [data, setData] = useState<ITaskProgramStoresViewDTO[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [gridFilter, dispatchGridFilter] = useGridFilter(DefaultGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const selectedTaskProgramId = pluginCtx.masterGrid.selectedItem?.idGlobal as string | undefined;

    useEffect(() => {
        setSelectedItem(undefined);
    }, [selectedTaskProgramId]);
    
    useEffect(() => {
        if (selectedTaskProgramId) {

            taskProgramProvider.viewStores(selectedTaskProgramId,  gridFilter, (response, totalCount) => {                
                setData(response)
                setTotalCount(totalCount)
            })
        }
    }, [selectedTaskProgramId, gridFilter])

    return (
        <PluginWrapper>
            <DefaultGrid
                key={selectedTaskProgramId}
                gridId={props.gridId}
                data={data}
                filter={gridFilter}
                totalCount={totalCount}
                plugin={props.plugin}
                hiddenPagination={undefined}
                selectedItem={selectedItem}
                dataProvider={taskProgramProvider}
                 getView={(gridFilter,callback) => {
                    taskProgramProvider.viewStores(selectedTaskProgramId as string, gridFilter, (e, t) => {
                        callback(e, t)
                        setTotalCount(t)
                    })
                }}
                onDoubleClick={(row) => props.onDoubleClick?.(row)}
                onSelect={(row) => setSelectedItem(row)}
                onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                onFilterDelete={(i) => { dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName }) }}
                onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
            />
        </PluginWrapper>
    )
}

export default TaskProgramItemDetailsGrid
